import React, { useMemo } from 'react';
import { useLocation } from 'react-router';
import { useTranslation } from '@askporter/config-provider';
import { captureException } from '@askporter/exception-logger';
import { copyToClipboard } from '@askporter/utils';
import { useBreadcrumbs } from '../../providers/breadcrumbs/BreadcrumbContext';
import { useToast } from '../../providers/toast';
import { Breadcrumbs } from '../../stories/Breadcrumbs';
import { generateBreadcrumbItems } from './utils';

export const GlobalBreadcrumbs: React.FC = () => {
  const { displayRoute, navigationRoute, injectedBreadcrumbs, loadingUids, concealedSections } = useBreadcrumbs();
  const location = useLocation();
  const basePath = location.pathname.split('/').filter(Boolean).join('/');
  const { showSuccess, showError } = useToast();
  const { t } = useTranslation();

  const copyFunction = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    const success = copyToClipboard(`${window.location.origin}/${basePath}`, captureException);
    if (success) {
      showSuccess(t('common:clipboard_success'));
    } else {
      showError(t('common:clipboard_error'));
    }
  };

  const items = useMemo(() => {
    return generateBreadcrumbItems({
      displayRoute,
      navigationRoute,
      injectedBreadcrumbs,
      loadingUids,
      concealedSections,
      t,
    });
  }, [displayRoute, navigationRoute, injectedBreadcrumbs, loadingUids, concealedSections, t]);

  // atm we don't want to show breadcrumbs on assets list or task list pages
  return <>{items.length >= 2 && <Breadcrumbs items={items} highlightLastItem onCopy={copyFunction} />}</>;
};
